module.exports = __webpack_public_path__ + "assets/img/43.317d4940.png";